export const DEFAULT_PAGINATION_PAGE_SIZE = 24;
